import { useMutation, UseMutationOptions } from 'react-query';

import { uploadDocumentImage } from '@app/store/transport-layer/upload/documents/images/upload';

function useUploadDocumentImage(
  options?: UseMutationOptions<
    { fileId: string; otp: string },
    Error,
    { base64: string; imageSrc: string }
  >
) {
  return useMutation<{ fileId: string; otp: string }, Error, { base64: string; imageSrc: string }>(
    ({ base64 }: { base64: string; imageSrc: string }) => {
      return uploadDocumentImage({ base64 });
    },
    options
  );
}

export default useUploadDocumentImage;
